import { render, staticRenderFns } from "./SoliSnack.vue?vue&type=template&id=e5dedd6a"
import script from "./SoliSnack.vue?vue&type=script&lang=js"
export * from "./SoliSnack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports